module.exports = __webpack_public_path__ + "img/status-wallet.a627079f.png";